/* eslint-disable */

import React from 'react';

export default function WireframeFooterMobile(props: { desktopLink: string }) {
    return (
        <>
            <style
                jsx
                global
            >{`
                .c24m-footer {
                    -webkit-flex: none;
                    -ms-flex: none;
                    flex: none;
                    display: block;
                    width: 100%;
                    border-top: 1px solid #dcdcdc;
                    background-color: #ffffff;
                    color: #333333;
                }

                .c24m-footer.c24m-footer-gray {
                    background-color: #f4f4f4;
                }

                .c24m-footer-content {
                    padding: 10px;
                    text-align: center;
                    font-size: 12px;
                    line-height: 16px;
                }

                body:not(.c24-app-context).c24-tap-bar-visible .c24m-footer-content {
                    margin-bottom: calc(70px + env(safe-area-inset-bottom, 0px));
                }

                .c24m-footer-list {
                    padding: 10px 0 0;
                    display: inline-block;
                    margin: 0 auto;
                }

                .c24m-footer-list li {
                    display: inline-block;
                    padding-bottom: 5px;
                }

                .c24m-footer-content a,
                .c24m-footer a {
                    color: #333333;
                }

                .c24m-footer-content a:hover,
                .c24m-footer a:hover {
                    text-decoration: none;
                }

                .c24m-footer-content p {
                    margin: 0;
                    padding: 0;
                }

                .c24m-footer-content .c24m-desktop-link {
                    padding: 5px 0;
                    display: block;
                    color: #0563c1;
                }
                *.hidden {
                    display: none !important;
                }
                .body--app .c24m-desktop-link {
                    display: none;
                }
            `}</style>
            <footer
                className={`c24m-footer `}
                data-nosnippet="true"
            >
                <div className={`c24m-footer-content clearfix`}>
                    <ul className={`c24m-footer-list clearfix`}>
                        <li>
                            <a
                                className={`c24-footer-link-contact`}
                                href={`https://m.check24.de/unternehmen/kontakt/`}
                            >
                                Kontakt&nbsp;
                            </a>
                        </li>
                        <li>
                            <a href={`https://jobs.check24.de/de/`}>|&nbsp;&nbsp;Karriere&nbsp;</a>
                        </li>
                        <li>
                            <a href={`https://m.check24.de/unternehmen/presse/`}>|&nbsp;&nbsp;Presse&nbsp;</a>
                        </li>
                        <li>
                            <a
                                className={`c24-footer-nav-ele c24-footer-link-conditions`}
                                href={`https://individualreisen.check24.de/dateien/agb.pdf`}
                                title="AGB"
                            >
                                |&nbsp;&nbsp;AGB&nbsp;
                            </a>
                        </li>
                        <li>
                            <a
                                className={`c24-footer-nav-ele c24-footer-link-privacy`}
                                href={`https://individualreisen.check24.de/dateien/datenschutzhinweise.pdf?v=4`}
                                title="Datenschutz"
                            >
                                |&nbsp;&nbsp;Datenschutz&nbsp;
                            </a>
                        </li>
                        <li>
                            <a
                                className={`c24-footer-nav-ele c24-footer-link-imprint`}
                                href={`https://www.check24.de/unternehmen/impressum/#comp50`}
                                title="Impressum"
                            >
                                |&nbsp;&nbsp;Impressum
                            </a>
                        </li>
                    </ul>
                    <p className={`c24m-copyright`}>
                        &copy; 2025 CHECK24 Vergleichsportal Individualreisen GmbH, Düsseldorf{' '}
                    </p>
                    <p>
                        <a
                            className={`c24m-desktop-link`}
                            href={`${props.desktopLink}`}
                            target="_blank"
                        >
                            zur Desktopversion
                        </a>
                    </p>
                </div>
            </footer>
        </>
    );
}
